module.exports = __webpack_public_path__ + "static/ccc-logo-2e0f00f078f44375f9cf9e7778e8a86e.png";